var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center"},[_c('img',{attrs:{"src":require("@/assets/warning.png")}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }